import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import wallets from "./wallets.module";
import goalLink from "./goalLink.module";
import mypurcent from "./mypurcent.module"
import getContentExcel from "./getContentExcel.module"
import getDataTable from "./getDataTable.module"
import internalTransfer from "./internalTransfer.module"
import dollarRate from "./dollarRate.module"
import inquiryEnamad from "./inquiryEnamad.module";
import registerWithEnamad from "./registerWithEnamad.module";
import getNotification from "./getNotification.module";
import register from "./register.module";
import getUser from "./getUser.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    wallets,
    goalLink,
    mypurcent,
    getContentExcel,
    getDataTable,
    internalTransfer,
    dollarRate,
    inquiryEnamad,
    registerWithEnamad,
    getNotification,
    register,
    getUser
  }
});
